import React from 'react'

function About() {
    return (
        <div>
            Create Post Read and Delete the Blogs
        </div>
    )
}

export default About